module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Termin_Layer.98e85f21.jpg";